/**
 * Data Freshness API Service
 * 
 * Handles data freshness status for all engines.
 * Migrated from seo-engine-webtools-customer-module
 */

import customerApi, { USE_MOCK_DATA } from './customerApi';
import { DataFreshnessResponse } from '@/types/customer';

// Mock data for development
const freshnessMockData: DataFreshnessResponse = {
  siteId: 1,
  engines: [
    {
      engineType: 'GSC',
      dataTypes: [
        { dataType: 'SEARCH_ANALYTICS', lastUpdated: '2026-01-21T23:00:00Z', recordCount: 125000, freshnessStatus: 'FRESH' },
        { dataType: 'INDEX_STATUS', lastUpdated: '2026-01-21T22:30:00Z', recordCount: 15000, freshnessStatus: 'FRESH' },
        { dataType: 'CRAWL_ERRORS', lastUpdated: '2026-01-21T22:00:00Z', recordCount: 195, freshnessStatus: 'FRESH' },
        { dataType: 'SITEMAPS', lastUpdated: '2026-01-21T21:00:00Z', recordCount: 4, freshnessStatus: 'FRESH' },
      ],
      lastSuccessfulSync: '2026-01-21T23:00:00Z',
      nextScheduledSync: '2026-01-22T06:00:00Z',
      healthStatus: 'HEALTHY',
    },
    {
      engineType: 'BING',
      dataTypes: [
        { dataType: 'SEARCH_ANALYTICS', lastUpdated: '2026-01-21T20:00:00Z', recordCount: 98000, freshnessStatus: 'FRESH' },
        { dataType: 'INDEX_STATUS', lastUpdated: '2026-01-21T19:30:00Z', recordCount: 14500, freshnessStatus: 'FRESH' },
        { dataType: 'SITEMAPS', lastUpdated: '2026-01-21T19:00:00Z', recordCount: 4, freshnessStatus: 'FRESH' },
      ],
      lastSuccessfulSync: '2026-01-21T20:00:00Z',
      nextScheduledSync: '2026-01-22T08:00:00Z',
      healthStatus: 'HEALTHY',
    },
    {
      engineType: 'GA4',
      dataTypes: [
        { dataType: 'ANALYTICS_SESSIONS', lastUpdated: '2026-01-21T18:00:00Z', recordCount: 45000, freshnessStatus: 'FRESH' },
        { dataType: 'ANALYTICS_EVENTS', lastUpdated: '2026-01-21T18:00:00Z', recordCount: 320000, freshnessStatus: 'FRESH' },
      ],
      lastSuccessfulSync: '2026-01-21T18:00:00Z',
      nextScheduledSync: '2026-01-22T00:00:00Z',
      healthStatus: 'HEALTHY',
    },
    {
      engineType: 'GBP',
      dataTypes: [
        { dataType: 'REVIEWS', lastUpdated: '2026-01-20T12:00:00Z', recordCount: 342, freshnessStatus: 'STALE', staleDays: 2 },
        { dataType: 'Q_AND_A', lastUpdated: '2026-01-20T12:00:00Z', recordCount: 28, freshnessStatus: 'STALE', staleDays: 2 },
        { dataType: 'PHOTOS', lastUpdated: '2026-01-15T10:00:00Z', recordCount: 45, freshnessStatus: 'STALE', staleDays: 7 },
      ],
      lastSuccessfulSync: '2026-01-20T12:00:00Z',
      nextScheduledSync: '2026-01-22T12:00:00Z',
      healthStatus: 'STALE',
    },
  ],
  overallHealthScore: 85,
};

/**
 * Get data freshness status for a site
 */
export async function getDataFreshness(siteId: number): Promise<DataFreshnessResponse> {
  if (USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 500));
    return freshnessMockData;
  }

  const response = await customerApi.get<{ success: boolean; data: DataFreshnessResponse }>(
    `/webtools/sites/${siteId}/freshness`
  );
  return response.data.data;
}

export default {
  getDataFreshness,
};
